import Swiper from "swiper/bundle";

const MaterialCardsSlider = () => {
  const materialsSliders = [...document.querySelectorAll(".material-cards__slider")];

  if (materialsSliders.length > 0) {
    materialsSliders.forEach((materialsSlider) => {
      const materialsCarousel = new Swiper(materialsSlider, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: ".material-cards__slider-pagination",
        },
        navigation: {
          nextEl: ".material-cards__slider-button-next",
          prevEl: ".material-cards__slider-button-prev",
        },
      });

    })
  }

}

export default MaterialCardsSlider;